module.exports = __webpack_public_path__ + "img/super-priz.67335f54.svg";